export const determineButtonProperties = (isPaused: boolean, status: string) => {
	let actionName = '';
	let iconName = '';

	if (isPaused && status?.toLowerCase() !== 'trash') {
		actionName = 'Remove from Cache';
		iconName = 'chart-breakout-circle';
	} else if (status?.toLowerCase() === 'trash') {
		actionName = 'Remove from Trash';
		iconName = 'chart-breakout-square';
	} else {
		actionName = '—';
		iconName = '';
	}
	return {
		buttonProperties: {
			actionName,
			iconName,
		},
	};
};

export function getCacheDataPreview(text: string, wordCount = 3): { preview: string; isTruncated: boolean } {
	const words = text.trim().split(/\s+/).filter(Boolean);
	if (words.length <= wordCount) {
		return { preview: words.join(' '), isTruncated: false };
	}
	return { preview: words.slice(0, wordCount).join(' '), isTruncated: true };
}
